import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Tab } from "@headlessui/react";
import { MdVerified } from "react-icons/md";
import { TiTick, TiPlus } from "react-icons/ti";
import { BsFillChatLeftTextFill } from "react-icons/bs";
import {
  buyPost,
  buyPremium,
  checkPremium,
  createChatRoom,
  getPostByCreator,
  getSpecificCreator,
  subCountOfCreator,
  getBio
} from "../../service/api";
import TopBar from "./TopBar";
import { FaSpinner } from "react-icons/fa";

function CreatorProfilePage() {
  const [creatorProfile, setCreatorProfile] = useState();
  const [posts, setPosts] = useState();
  const [isPremium, setIsPremium] = useState(false);
  const { email } = useParams();

  const [isLoading, setisLoading] = useState(true);
  const [bio, setBio] = useState("");
  const [premiumMemeberCount, setpremiumMemeberCount] = useState(0);
  const [totalPosts, settotalPosts] = useState(0);

  const user_data = JSON.parse(sessionStorage.getItem("userdata"));
  let user_email = user_data.email;

  const navigate = useNavigate();

  const check = async () => {
    setisLoading(true);

    const premiumMemberCount = await subCountOfCreator(email);

    setpremiumMemeberCount(premiumMemberCount);

    const premium = await checkPremium({
      email: user_email,
      creator_email: email,
    });
    setIsPremium(premium);

    const posts = await getPostByCreator({
      email: user_email,
      creator_email: email,
    });
    
    var response = await getBio(email);
    setBio(response);

    setPosts(posts);
    settotalPosts(posts.owned.length+posts.notOwned.length);
    const profile = await getSpecificCreator(email);
    setCreatorProfile(profile);

    setisLoading(false);
  };

  useEffect(() => {
    check();
  }, []);

  const onFollow = async () => {
    await buyPremium({ email: user_email, creator_email: email });
  };

  return (
    <>
      <div className="bg flex flex-col bg h-full min-h-screen">
        <TopBar />
        <div className="flex justify-center">
          <div className="md:w-1/2">
            {isLoading && (
              <center className="py-20 my-20">
                <FaSpinner icon="spinner" className="spinner" size={70} />
              </center>
            )}
            {!isLoading && (
              <div className="m-5 w-full">
                {creatorProfile && (
                  <div>
                    <div
                      className={
                        "w-full bg-cover bg-no-repeat bg-center h-48 rounded-lg"
                      }
                      style={{
                        backgroundImage:
                          'url("' +
                          creatorProfile.banner +
                          '")',
                      }}
                    ></div>
                    <div className="p-4 flex w-full">
                      <div className="flex flex-col text-center w-full">
                        <div className="-mt-24 w-full">
                          <div className="rounded-full h-36 w-36">
                            <img
                              className="rounded-full w-full h-full border-4"
                              src={
                                "" + creatorProfile.image
                              }
                              alt=""
                            />
                          </div>
                          <div className="mt-2 flex justify-between items-center w-full text-5xl font-semibold">
                            <span className="flex gap-2 text-slate-200">
                              {creatorProfile.name} <MdVerified color="green" />
                            </span>

                            {isPremium ? (
                              <button
                                className="float-right flex items-center p-2 bg-white font-bold text-teal-500 rounded-md text-lg"
                                disabled
                              >
                                <TiTick />
                                Following
                              </button>
                            ) : (
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  onFollow();
                                }}
                                className="float-right flex items-center p-2 bg-white font-bold text-blue-500 rounded-md text-lg"
                              >
                                <TiPlus />
                                Follow
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <span className="flex gap-2 text-black mb-5">
                              {bio}
                            </span>
                    <div className=" flex align-middle justify-center px-5">
                      <div className="text-2xl mr-6 p-2 bg-[#fff] rounded-lg">Followers : {premiumMemeberCount}</div>
                      <span className="text-2xl ml-6 p-2  bg-[#fff] rounded-lg">Posts : {totalPosts}</span>
                    </div>
                    <div className="flex items-center justify-center mt-5 w-full">
                      {isPremium ? (
                        <div>
                          {Object.values(posts).map((posts) =>
                            posts.map((post, index) => (
                              <div
                                className="flex flex-col gap-5 w-full my-4 rounded p-2.5"
                                key={index}
                              >
                                <div className="flex w-full items-center justify-between">
                                  <div className="flex items-center gap-2">
                                    <img
                                      src={
                                        "" +
                                        creatorProfile.image
                                      }
                                      alt="user"
                                      className="w-12 h-12 rounded-full object-cover object-center"
                                    />
                                    <h5 className="text-2xl font-semibold text-white">
                                      {creatorProfile.name}
                                    </h5>
                                  </div>
                                </div>
                                <div className="mt-1">
                                  <img
                                    src={
                                      "" + post.picture
                                    }
                                    alt="user"
                                    className="w-full h-48 object-cover rounded-t-xl object-center"
                                  />
                                  <div className="px-5 py-1.5 flex items-start bg-black bg-opacity-40 justify-between w-full text-white rounded-b-lg">
                                    <h5 className="font-semibold w-3/5">
                                      {post.caption}
                                    </h5>
                                  </div>
                                </div>
                              </div>
                            ))
                          )}
                        </div>
                      ) : (
                        <Tabs {...posts} {...creatorProfile} />
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
            <div
              className="fixed bottom-12 text-xl right-12 p-4 hover:cursor-pointer rounded-full bg-white"
              onClick={async () => {
                user_email = user_email.replaceAll(".", "_");
                user_email = user_email.replaceAll("@", "_");
                user_email = user_email.toLowerCase();

                let creator_email = email.replaceAll(".", "_");
                creator_email = creator_email.replaceAll("@", "_");
                creator_email = creator_email.toLowerCase();
                await createChatRoom(user_email, creator_email);
                navigate("/user/chats");
              }}
            >
              <BsFillChatLeftTextFill />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CreatorProfilePage;

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Tabs(props) {
  let [categories] = useState({
    Owned: props.owned,
    Buy: props.notOwned,
  });

  const onBuy = async (e) => {
    const user_data = JSON.parse(sessionStorage.getItem("userdata"));
    await buyPost({ email: user_data.email, post_id: e._id });
    window.location.reload();
  };

  return (
    <div className="w-full max-w-md px-2 py-5 sm:px-0">
      <Tab.Group>
        <Tab.List className="flex p-1 space-x-1 bg-blue-900/20 rounded-xl">
          {Object.keys(categories).map((tabName, index) => (
            <Tab
              key={index}
              className={({ selected }) =>
                classNames(
                  "w-full py-2.5 text-sm leading-5 font-medium text-blue-700 rounded-lg",
                  "focus:outline-none focus:ring-2 ring-offset-2 ring-offset-blue-400 ring-white ring-opacity-60",
                  selected
                    ? "bg-white shadow"
                    : "text-blue-100 hover:bg-white/[0.12] hover:text-white"
                )
              }
            >
              {tabName}
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels className="mt-2">
          {Object.values(categories).map((posts, idx) => (
            <Tab.Panel key={idx}>
              {posts.map((post, index) => (
                <div
                  className="flex flex-col gap-5 w-full my-4 rounded p-2.5"
                  key={index}
                >
                  <div className="flex w-full items-center justify-between">
                    <div className="flex items-center gap-2">
                      <img
                        src={"" + props.image}
                        alt="user"
                        className="w-12 h-12 rounded-full object-cover object-center"
                      />
                      <h1 className="text-2xl font-semibold text-white">
                        {props.name}
                      </h1>
                    </div>
                    {props.notOwned.includes(post) && (
                      <button
                        className="font-bold px-2.5 shadow-md py-0.5 text-blue-500 bg-white rounded-lg"
                        onClick={(e) => {
                          e.preventDefault();
                          onBuy(post);
                        }}
                      >
                        Buy
                      </button>
                    )}
                  </div>
                  <div className="mt-1">
                    <img
                      src={"" + post.picture}
                      alt="user"
                      className={classNames(
                        "w-full h-48 object-cover rounded-xl object-center",
                        props.notOwned.includes(post)
                          ? "blur-md rounded-t-xl"
                          : ""
                      )}
                    />
                    {props.notOwned.includes(post) && (
                      <div className="px-5 py-1.5 flex items-start bg-black bg-opacity-40 justify-between w-full text-white rounded-b-lg">
                        <h5 className="font-semibold w-3/5">{post.caption}</h5>
                        <h6 className="flex items-center">₹ {post.fees}</h6>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
}
